import React from 'react'
import './BetaVersionBadge.css'

const SIZES = {
  sm: 'qn-beta-badge--sm',
  md: 'qn-beta-badge--md',
  lg: 'qn-beta-badge--lg'
}

/**
 * Shared product-status chip. Size is chosen by the placement: compact in
 * headers, a step larger where it replaces the Study Helper brand word, and
 * largest on the public sign-in page under the card.
 */
const BetaVersionBadge = ({ size = 'md' }) => {
  const sizeClass = SIZES[size] || SIZES.md
  return (
    <span className={`qn-beta-badge ${sizeClass}`}>
      Beta Version
    </span>
  )
}

export default BetaVersionBadge
